import { lazy } from 'react';
import App from './App';

export default [
  {
    component: App,
    routes: [
      {
        path: '/',
        exact: true,
        component: lazy(() => import('./pages/home')),
      },
      {
        path: '/details/:groupId',
        exact: true,
        authentication: true,
        component: lazy(() => import('./pages/artDetails')),
      },
      {
        path: '/m',
        exact: true,
        component: lazy(() => import('@Pages/m/home')),
      },
      {
        path: '/m/details/:groupId',
        exact: true,
        component: lazy(() => import('@Pages/m/detail')),
      },
      {
        path: '*',
        component: lazy(() => import('./pages/notFound')),
      },
    ],
  },
];
